import { SET_MENU_CARD_COPY_TASKS, SET_MENU_CARD_UPDATED_AT } from '../../actionTypes/menuCardCopyTask'

const initialState = {
	tasks: null,
	menuCardUpdatedAt: null,
}

export function menuCardCopyTaskReducer(state = initialState, action) {
	switch (action.type) {
		case SET_MENU_CARD_COPY_TASKS:
			return {
				...state,
				tasks: action.value,
			}
		case SET_MENU_CARD_UPDATED_AT:
			return {
				...state,
				menuCardUpdatedAt: action.value,
			}
		default:
			return state
	}
}
